import { dataHooks } from '@wix/data-hooks'

export const storesFunnelLoaderDataHooks = dataHooks<{
  title: {}
  back: {}
  progressBar: {}
  phaseText: { index: number }
}>('stores-funnel-loader')
